var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "package-offer",
      style: _vm.spacingStyle,
      attrs: { "aria-labelledby": _vm.item.id + "-title" }
    },
    [
      _c("header", { staticClass: "package-offer__header" }, [
        _vm.presentation.eyebrow
          ? _c("p", { staticClass: "package-offer__eyebrow" }, [
              _vm._v(_vm._s(_vm.presentation.eyebrow))
            ])
          : _vm._e(),
        _c("h2", { attrs: { id: _vm.item.id + "-title" } }, [
          _vm._v(_vm._s(_vm.presentation.title))
        ]),
        _vm.presentation.descriptionHtml
          ? _c("div", {
              staticClass: "package-offer__description brand-agreement-text",
              domProps: {
                innerHTML: _vm._s(
                  _vm.sanitize(_vm.presentation.descriptionHtml)
                )
              }
            })
          : _vm._e()
      ]),
      _vm.decisionWarning
        ? _c(
            "p",
            {
              staticClass: "package-offer__decision-warning",
              attrs: { role: "status" }
            },
            [_vm._v(_vm._s(_vm.decisionWarning))]
          )
        : _vm._e(),
      _c(
        "div",
        {
          class: [
            "package-offer__options",
            _vm.optionLayoutClass,
            { "package-offer__invalid": _vm.optionsInvalid }
          ],
          attrs: {
            tabindex: _vm.optionsInvalid ? -1 : null,
            "aria-invalid": _vm.optionsInvalid ? "true" : null
          }
        },
        _vm._l(_vm.options, function(option) {
          return _c(
            "article",
            { key: option.id, class: _vm.optionClass(option) },
            [
              option.badge
                ? _c("span", { staticClass: "package-offer__badge" }, [
                    _vm._v(_vm._s(option.badge))
                  ])
                : _vm._e(),
              _c("div", { staticClass: "package-offer__option-heading" }, [
                _c("h3", [_vm._v(_vm._s(option.title))])
              ]),
              option.descriptionHtml
                ? _c("div", {
                    staticClass:
                      "package-offer__option-description brand-agreement-text",
                    domProps: {
                      innerHTML: _vm._s(_vm.sanitize(option.descriptionHtml))
                    }
                  })
                : _vm._e(),
              _c(
                "div",
                { staticClass: "package-offer__option-footer" },
                [
                  _c("option-price", { attrs: { option: option } }),
                  _vm.selectionMode !== "FIXED" && !_vm.readOnly
                    ? _c(
                        "button",
                        {
                          class: [
                            "package-offer__option-action",
                            {
                              "package-offer__option-action--selected": _vm.selectedOptionIds.includes(
                                option.id
                              )
                            }
                          ],
                          attrs: {
                            type: "button",
                            "aria-pressed": _vm.selectedOptionIds.includes(
                              option.id
                            ),
                            disabled: _vm.optionDisabled(option.id)
                          },
                          on: {
                            click: function($event) {
                              return _vm.toggleOption(option.id)
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                option.required
                                  ? option.requiredLabel || "Included"
                                  : _vm.selectedOptionIds.includes(option.id)
                                  ? _vm.selectedOptionLabel
                                  : _vm.chooseOptionLabel
                              ) +
                              " "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        }),
        0
      ),
      _vm.eligibleAddOns.length
        ? _c(
            "section",
            {
              class: [
                "package-offer__section",
                { "package-offer__invalid": _vm.addOnsInvalid }
              ],
              attrs: {
                "aria-label":
                  _vm.presentation.addOnsLabel ||
                  _vm.$t("agreement-package-offer.add-ons"),
                "aria-invalid": _vm.addOnsInvalid ? "true" : null,
                tabindex: _vm.addOnsInvalid ? -1 : null
              }
            },
            [
              _vm.presentation.addOnsLabel
                ? _c("h3", [_vm._v(_vm._s(_vm.presentation.addOnsLabel))])
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "package-offer__add-on-list",
                  class: _vm.optionLayoutClass
                },
                _vm._l(_vm.eligibleAddOns, function(addOn) {
                  return _c(
                    "article",
                    {
                      key: addOn.id,
                      class: [
                        "package-offer__add-on",
                        {
                          "package-offer__add-on--selected": _vm.isAddOnSelected(
                            addOn.id
                          ),
                          "package-offer__add-on--required": addOn.required
                        }
                      ],
                      on: {
                        click: function($event) {
                          return _vm.toggleAddOn(addOn)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "package-offer__add-on-heading" },
                        [
                          _c("input", {
                            attrs: {
                              id: _vm.addOnInputId(addOn.id),
                              type: "checkbox",
                              disabled: _vm.readOnly || addOn.required,
                              "aria-label": addOn.title
                            },
                            domProps: {
                              checked: _vm.isAddOnSelected(addOn.id)
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                              },
                              change: function($event) {
                                return _vm.toggleAddOn(addOn)
                              }
                            }
                          }),
                          _c(
                            "div",
                            { staticClass: "package-offer__add-on-copy" },
                            [
                              _c("strong", [_vm._v(_vm._s(addOn.title))]),
                              addOn.descriptionHtml
                                ? _c("div", {
                                    staticClass:
                                      "package-offer__option-description brand-agreement-text",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.sanitize(addOn.descriptionHtml)
                                      )
                                    }
                                  })
                                : _vm._e()
                            ]
                          )
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "package-offer__add-on-footer" },
                        [
                          _c(
                            "div",
                            { staticClass: "package-offer__price" },
                            [
                              _vm.addOnOneTimePrice(addOn)
                                ? _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.labeledPrice(
                                          _vm.addOnOneTimePrice(addOn),
                                          addOn
                                        )
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._l(_vm.addOnRecurringPrices(addOn), function(
                                price,
                                priceIndex
                              ) {
                                return _c(
                                  "strong",
                                  {
                                    key: price.id || price.label || priceIndex
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.labeledPrice(price.amount, addOn)
                                      )
                                    )
                                  ]
                                )
                              }),
                              _vm.addOnDepositPrice(addOn)
                                ? _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.labeledPrice(
                                          _vm.addOnDepositPrice(addOn),
                                          addOn
                                        )
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm.isAdjustable(addOn) &&
                          _vm.isAddOnSelected(addOn.id)
                            ? _c("input", {
                                attrs: {
                                  type: "number",
                                  min: _vm.quantityRules(addOn).minimum,
                                  max: _vm.quantityRules(addOn).maximum,
                                  step: _vm.quantityRules(addOn).step,
                                  "aria-label": addOn.title + " quantity"
                                },
                                domProps: {
                                  value: _vm.addOnQuantity(addOn.id)
                                },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                  },
                                  change: function($event) {
                                    return _vm.setAddOnQuantity(
                                      addOn,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                }),
                0
              )
            ]
          )
        : _vm._e(),
      _vm.quoteError && !_vm.decisionWarning
        ? _c("div", { staticClass: "package-offer__quote-feedback" }, [
            _vm.quoteError
              ? _c(
                  "div",
                  {
                    staticClass: "package-offer__quote-error",
                    attrs: { role: "alert" }
                  },
                  [
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.$t("agreement-package-offer.quote-error"))
                      )
                    ]),
                    _c(
                      "button",
                      {
                        staticClass:
                          "package-offer__retry brand-agreement-button",
                        attrs: { type: "button" },
                        on: { click: _vm.requestQuote }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("agreement-package-offer.retry")) +
                            " "
                        )
                      ]
                    )
                  ]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm.visiblePaymentChoices.length
        ? _c(
            "section",
            {
              class: [
                "package-offer__section",
                "package-offer__payment-section",
                { "package-offer__invalid": _vm.paymentChoiceInvalid }
              ],
              attrs: {
                "aria-label":
                  _vm.presentation.paymentChoiceLabel ||
                  _vm.$t("agreement-package-offer.payment-choice"),
                "aria-busy": _vm.quoteLoading ? "true" : "false",
                "aria-invalid": _vm.paymentChoiceInvalid ? "true" : null,
                tabindex: _vm.paymentChoiceInvalid ? -1 : null
              }
            },
            [
              _vm.presentation.paymentChoiceLabel
                ? _c("h3", [
                    _vm._v(_vm._s(_vm.presentation.paymentChoiceLabel))
                  ])
                : _vm._e(),
              _vm.quoteLoading
                ? _c(
                    "p",
                    {
                      staticClass: "package-offer__quote-status",
                      attrs: { role: "status" }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("agreement-package-offer.updating-quote")
                          ) +
                          " "
                      )
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "package-offer__payment-choices" },
                _vm._l(_vm.visiblePaymentChoices, function(choice) {
                  return _c(
                    "article",
                    {
                      key: choice.id,
                      class: [
                        "package-offer__payment-choice",
                        {
                          "package-offer__payment-choice--selected":
                            _vm.visiblePaymentChoices.length > 1 &&
                            _vm.selection.paymentChoiceId === choice.id,
                          "package-offer__payment-choice--single":
                            _vm.visiblePaymentChoices.length === 1
                        }
                      ]
                    },
                    [
                      _c(
                        "button",
                        {
                          attrs: {
                            type: "button",
                            "aria-pressed":
                              _vm.selection.paymentChoiceId === choice.id,
                            disabled: _vm.readOnly
                          },
                          on: {
                            click: function($event) {
                              return _vm.setPaymentChoice(choice.id)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "package-offer__payment-choice-title"
                            },
                            [
                              _c("strong", [_vm._v(_vm._s(choice.label))]),
                              _vm.paymentChoiceAmount(choice)
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "package-offer__payment-choice-amount"
                                    },
                                    [
                                      _vm.paymentChoiceOriginalAmount(choice)
                                        ? _c("s", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.paymentChoiceOriginalAmount(
                                                  choice
                                                )
                                              )
                                            )
                                          ])
                                        : _vm._e(),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.paymentChoiceAmount(choice)
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ),
                          choice.description
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "package-offer__payment-choice-description"
                                },
                                [_vm._v(_vm._s(choice.description))]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm.selection.paymentChoiceId === choice.id &&
                      (_vm.paymentTaxBreakdown.length ||
                        _vm.paymentChoiceTerms(choice).length)
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "package-offer__payment-choice-details"
                            },
                            [
                              _vm._l(_vm.paymentTaxBreakdown, function(
                                row,
                                rowIndex
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: row.label + "-" + rowIndex,
                                    staticClass:
                                      "package-offer__payment-choice-term"
                                  },
                                  [
                                    _c("strong", [_vm._v(_vm._s(row.label))]),
                                    _c("strong", [_vm._v(_vm._s(row.value))])
                                  ]
                                )
                              }),
                              _vm._l(_vm.paymentChoiceTerms(choice), function(
                                term
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: term.id,
                                    staticClass:
                                      "package-offer__payment-choice-term"
                                  },
                                  [
                                    _c("strong", [_vm._v(_vm._s(term.label))]),
                                    _c("strong", [_vm._v(_vm._s(term.value))])
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        : _vm._e()
                    ]
                  )
                }),
                0
              )
            ]
          )
        : _vm._e(),
      _c("p", { staticClass: "sr-only", attrs: { "aria-live": "polite" } }, [
        _vm._v(_vm._s(_vm.announcement))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }